import { RevisionsStatus } from 'graphql/models/extended';
import { ContactType } from 'graphql/models/generated';
import { AccountRole, AccountTypeENUM } from 'models/account.model';
import { DropdownItem } from 'models/dropdown.model';
import { OfferTemplateSettingsItemType, OfferTemplateSettingsContentType } from 'models/offer-template-settings.model';

// TODO: add type like AdditionalAddressItem
export const SALUTATION: DropdownItem[] = [
  { title: 'FORMS.ADDRESS.MISTER', value: 'MR' },
  { title: 'FORMS.ADDRESS.MISS', value: 'MS' }
];

// TODO: add type like AdditionalAddressItem
export const COUNTRY_LIST: DropdownItem[] = [
  { title: 'FORMS.COUNTRY_LIST.DE', value: 'DE' },
  { title: 'FORMS.COUNTRY_LIST.AL', value: 'AL' },
  { title: 'FORMS.COUNTRY_LIST.BE', value: 'BE' },
  { title: 'FORMS.COUNTRY_LIST.BA', value: 'BA' },
  { title: 'FORMS.COUNTRY_LIST.BG', value: 'BG' },
  { title: 'FORMS.COUNTRY_LIST.DK', value: 'DK' },
  { title: 'FORMS.COUNTRY_LIST.FR', value: 'FR' },
  { title: 'FORMS.COUNTRY_LIST.GR', value: 'GR' },
  { title: 'FORMS.COUNTRY_LIST.IS', value: 'IS' },
  { title: 'FORMS.COUNTRY_LIST.IT', value: 'IT' },
  { title: 'FORMS.COUNTRY_LIST.XK', value: 'XK' },
  { title: 'FORMS.COUNTRY_LIST.HR', value: 'HR' },
  { title: 'FORMS.COUNTRY_LIST.LU', value: 'LU' },
  { title: 'FORMS.COUNTRY_LIST.MK', value: 'MK' },
  { title: 'FORMS.COUNTRY_LIST.ME', value: 'ME' },
  { title: 'FORMS.COUNTRY_LIST.NL', value: 'NL' },
  { title: 'FORMS.COUNTRY_LIST.AT', value: 'AT' },
  { title: 'FORMS.COUNTRY_LIST.PL', value: 'PL' },
  { title: 'FORMS.COUNTRY_LIST.PT', value: 'PT' },
  { title: 'FORMS.COUNTRY_LIST.RO', value: 'RO' },
  { title: 'FORMS.COUNTRY_LIST.CH', value: 'CH' },
  { title: 'FORMS.COUNTRY_LIST.RS', value: 'RS' },
  { title: 'FORMS.COUNTRY_LIST.SK', value: 'SK' },
  { title: 'FORMS.COUNTRY_LIST.SI', value: 'SI' },
  { title: 'FORMS.COUNTRY_LIST.ES', value: 'ES' },
  { title: 'FORMS.COUNTRY_LIST.CZ', value: 'CZ' },
  { title: 'FORMS.COUNTRY_LIST.HU', value: 'HU' }
];

// TODO: add type like AdditionalAddressItem
export const CONDITION_TYPES: DropdownItem[] = [
  { title: 'FORMS.CUSTOMER.CONDITIONS.EK_SURCHARGE', value: 'SURCHARGE' },
  { title: 'FORMS.CUSTOMER.CONDITIONS.PL_DISCOUNT', value: 'DISCOUNT' }
];

// TOOD: use Map with value as key, and title as value?
export const ADDITIONAL_ADDRESS_TYPES: DropdownItem<ContactType>[] = [
  { title: 'FORMS.OBJECT.BASIC_INFO.ADDRESS_TYPES.ARCHITECT', value: 'ARCHITECT' },
  { title: 'FORMS.OBJECT.BASIC_INFO.ADDRESS_TYPES.DEVELOPER', value: 'DEVELOPER' },
  { title: 'FORMS.OBJECT.BASIC_INFO.ADDRESS_TYPES.BUILDER', value: 'BUILDER' },
  { title: 'FORMS.OBJECT.BASIC_INFO.ADDRESS_TYPES.GENERAL_CONTRACTOR', value: 'GENERAL_CONTRACTOR' },
  { title: 'FORMS.OBJECT.BASIC_INFO.ADDRESS_TYPES.PROCESSOR', value: 'PROCESSOR' }
];

export const VERSION_NUMBER_LIST: DropdownItem[] = [
  { title: '-01', value: '-01' },
  { title: '_01', value: '_01 ' },
  { title: '-V1', value: '-V1 ' },
  { title: '_V1', value: '_V1 ' }
];

export const VIEW_SETTINGS: DropdownItem[] = [
  { title: 'FORMS.ACCOUNT.VIEW_SETTINGS_OPTIONS.FUNCTION', value: 'FUNCTION' },
  { title: 'FORMS.ACCOUNT.VIEW_SETTINGS_OPTIONS.DESIGN', value: 'DESIGN' }
];

export const ACCOUNT_ROLES: DropdownItem[] = [
  { title: 'FORMS.ACCOUNT_ROLE.USER', value: AccountRole.USER },
  { title: 'FORMS.ACCOUNT_ROLE.ADMIN', value: AccountRole.ADMIN }
];

export const ACCOUNT_TYPES: DropdownItem[] = [
  { title: 'DEALER', value: AccountTypeENUM.DEALER },
  { title: 'MANUFACTURER', value:  AccountTypeENUM.MANUFACTURER }
];

export const OFFER_TEMPLATE_FOOTER_TYPES: DropdownItem[] = [
  {
    title: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.FOOTER_TYPES.DEFAULT.TITLE',
    subTitle: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.FOOTER_TYPES.DEFAULT.SUBTITLE',
    value: OfferTemplateSettingsItemType.DEFAULT
  },
  {
    title: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.FOOTER_TYPES.CUSTOM_IMAGE.TITLE',
    subTitle: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.FOOTER_TYPES.CUSTOM_IMAGE.SUBTITLE',
    value: OfferTemplateSettingsItemType.CUSTOM_IMAGE
  }
];

export const OFFER_TEMPLATE_CONTENT_TYPES: DropdownItem[] = [
  {
    title: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.CONTENT_TYPES.SHORT_DESCRIPTION',
    value: OfferTemplateSettingsContentType.SHORT_DESCRIPTION
  },
  {
    title: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.CONTENT_TYPES.LONG_DESCRIPTION',
    value: OfferTemplateSettingsContentType.LONG_DESCRIPTION
  }
];

export const ITEMS_PER_PAGE: DropdownItem<number>[] = [
  { title: '10', value: 10 },
  { title: '20', value: 20 },
  { title: '50', value: 50 }
];

export const RFP_SUBJECT: DropdownItem[] = [
  { title: 'MODALS.RFP.SUBJECT', value: 'MODALS.RFP.SUBJECT' },
  { title: 'MODALS.RFP.SUBJECT2', value: 'MODALS.RFP.SUBJECT2' }
];

export const OFFER_STATUS: DropdownItem[] = [
  { title: 'OFFER.STATUS.ALL_ACTIVE', value: RevisionsStatus.ALL_ACTIVE },
  { title: 'OFFER.STATUS.NEW', value: RevisionsStatus.NEW },
  { title: 'OFFER.STATUS.PENDING', value: RevisionsStatus.PENDING_RFP },
  { title: 'OFFER.STATUS.ANSWERED_RFP', value: RevisionsStatus.ANSWERED_RFP },
  { title: 'OFFER.STATUS.IN_PROGRESS', value: RevisionsStatus.IN_PROGRESS },
  { title: 'OFFER.STATUS.CLOSED', value: RevisionsStatus.CLOSED },
  { title: 'OFFER.STATUS.SENT', value: RevisionsStatus.SENT }
];
